/* eslint-disable no-param-reassign */
const initState = {
  isGetPhoneCode: false,
  token: '',
  isLoginFail: false,
  customerData: {
    maskName: '', // 可以用來判斷是否已經登入
  },
  isLogin: false,
  finalTrPayOrderPageData: [],
  apiTrpayDepositExceptionMessage: '',
  apiRedirectUrl: '',
};

export function memberState(state = initState, action) {
  switch (action.type) {
    // 註冊用戶
    case 'SUBMIT_REGISTER_DATA': {
      return {
        ...state,
      };
    }
    // 註冊-獲取手機驗證碼
    case 'GET_PHONE_CODE': {
      return {
        ...state,
        isGetPhoneCode: action.payload,
      };
    }
    case 'SET_USER_TOKEN': {
      return {
        ...state,
      };
    }
    case 'LOGIN_FAIL': {
      state.isLoginFail = true;
      // if (state.isLoginFail) {
      //   $('#loginErrorModal').modal('show');
      // }
      return {
        ...state,
      };
    }
    case 'UPDATE_CUSTOMER_DATA': {
      // 打登出的時候會來更新這邊的資料把 customerData 裏面的 maskName 清空
      const loginStatus = action.payload !== '';
      return {
        ...state,
        customerData: {
          maskName: action.payload,
        },
        isLogin: loginStatus,
      };
    }
    case 'GET_TRPAY_ORDERPAGE_DATA': {
      return {
        ...state,
        finalTrPayOrderPageData: action.payload,
      };
    }
    case 'UPDATE_TRAYDEPOSIT_API_RESPONSE_MESSAGE': {
      return {
        ...state,
        apiTrpayDepositExceptionMessage: action.payload,
      };
    }
    case 'UPDATE_API_REDIRECT_URL': {
      return {
        ...state,
        apiRedirectUrl: action.payload,
      };
    }
    default:
      return state;
  }
}

export default memberState;
